import MokuHoldingCard from './MokuHoldingCard'

export default MokuHoldingCard
